import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Import Firestore
import {getStorage} from "firebase/storage"

const firebaseConfig = {
  // Your Firebase project configuration
  apiKey: "AIzaSyCIt95A5KcxItV1tMHgi-kMzTfAuQa8vqM",
  authDomain: "danceai-e04af.firebaseapp.com",
  projectId: "danceai-e04af",
  storageBucket: "danceai-e04af.appspot.com",
  messagingSenderId: "217881943779",
  appId: "1:217881943779:web:67b1a530ee690dce502fd6",
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth, Firestore and getStorage
const auth = getAuth(app);
const db = getFirestore(app); 
const storage = getStorage(app);

export { auth, db, app, storage};